import {EntityApiService} from '@dofleini/security';

class DpjOfficeApiService extends EntityApiService {


}

export default new DpjOfficeApiService('/ms-auth/api/dpjs');
